export default "__VITE_ASSET__CHNuLIAs__"